new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        banners: {
            bandCommuniqueDropdown: false,
        },
        mobile: (window.innerWidth > 991) ? false : true,
        tabletPortrait: (window.innerWidth > 767) ? true : false
    },
    created() {
        window.addEventListener("resize", this.screenHandler);
    },
    mounted() {
        this.secondBlock = true;
    },
    destroyed() {
        window.removeEventListener("resize", this.screenHandler);
    },
    methods: {
        screenHandler() {
            this.mobile = (window.innerWidth > 991) ? false : true;
            this.tabletPortrait = (window.innerWidth > 767) ? true : false;
        }
    }
})

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.home__faq').then(element => {
        const faqItems = document.querySelectorAll('.home__faq--list-item');

        if (faqItems.length > 0) {
            faqItems.forEach(item => {
                item.addEventListener('click', () => {
                    item.classList.toggle('active');
                });
            });
        }
    });

    waitForElementToExist('.categories').then(element => {
        // Verifica se tem pelo menos 8 filhos em desktop
        if (window.innerWidth >= 992) {
            const container = document.querySelector('#categories-home-carrousel');
            const items = Array.from(container.children);

            if (items.length < 8) {
                // Não inicializa o slick se tiver menos de 8 itens em desktop
                console.log('Slick não inicializado - menos de 8 itens em desktop:', items.length);
                return;
            }
        }

        $('#categories-home-carrousel').slick({
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 1000,
            infinite: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 8,
                    }
                }
            ]
        });
    });

    waitForElementToExist('.faixa-cupom').then(element => {
        const faixCupom = document.querySelector('.faixa-cupom');
        if (faixCupom) {
            const formButton = document.querySelector('.faixa-cupom-form p');
            var inputElement = document.getElementById("valorParaCopiar");
            if (inputElement) {
                var newValueInput = inputElement.getAttribute('data-value');
                inputElement.textContent = newValueInput;

                if (formButton) {
                    formButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        navigator.clipboard.writeText(newValueInput);

                        alert("Valor copiado: " + newValueInput);
                    });
                }
            }
        }
    });





    waitForElementToExist('.first-banner').then(element => {
        const banner = element.querySelector('#banner-categorias');

        if (banner) {
            $('#banner-categorias').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list');
        if (firstCarrousel) {
            $('.product_list').slick({
                arrows: true,
                prevArrow: $(".count-1 .count-prev"),
                nextArrow: $(".count-1 .count-next"),
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }

        /* Fix bug with slick on new product render (vitrine) */
        const elementosLazy = document.querySelectorAll('.lazy-img');

        elementosLazy.forEach(elemento => {
            const dataSrc = elemento.getAttribute('data-src');
            if (dataSrc) {
                elemento.setAttribute('src', dataSrc);
                elemento.removeAttribute('data-src');
            }
        });
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list');
        if (firstCarrousel) {
            $('.second-vitrine .product_list').slick({
                arrows: true,
                prevArrow: $(".count-2 .count-prev"),
                nextArrow: $(".count-2 .count-next"),
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.second-vitrine .product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }

        /* Fix bug with slick on new product render (vitrine) */
        const elementosLazy = document.querySelectorAll('.lazy-img');

        elementosLazy.forEach(elemento => {
            const dataSrc = elemento.getAttribute('data-src');
            if (dataSrc) {
                elemento.setAttribute('src', dataSrc);
                elemento.removeAttribute('data-src');
            }
        });
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list');
        if (firstCarrousel) {
            $('.third-vitrine .product_list').slick({
                arrows: true,
                prevArrow: $(".count-3 .count-prev"),
                nextArrow: $(".count-3 .count-next"),
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.third-vitrine .product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }

        /* Fix bug with slick on new product render (vitrine) */
        const elementosLazy = document.querySelectorAll('.lazy-img');

        elementosLazy.forEach(elemento => {
            const dataSrc = elemento.getAttribute('data-src');
            if (dataSrc) {
                elemento.setAttribute('src', dataSrc);
                elemento.removeAttribute('data-src');
            }
        });
    });



    waitForElementToExist('.banner-momentos').then(element => {
        const banner = element.querySelector('#banner-momentos');

        if (banner) {
            $('#banner-momentos').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,

                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    // waitForElementToExist('.faixa-comunicado').then(element => {
    //     const banner = element.querySelector('#faixa-comunicado');

    //     if(banner) {
    //         $('#faixa-comunicado').slick({
    //             arrows: false,
    //             dots: false,
    //             infinite: false,
    //             mobileFirst: true,
    //             autoplay: true,
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             speed: 700,

    //             responsive: [
    //                 {
    //                     breakpoint: 991,
    //                     settings: "unslick"
    //                 }
    //             ]
    //         });
    //     }
    // });

    waitForElementToExist('.banner-instagram').then(element => {
        const banner = element.querySelector('.banner-instagram__list');

        if (banner) {
            $('.banner-instagram__list').slick({
                arrows: true,
                prevArrow: $(".banner-instagram .count-3 .count-prev"),
                nextArrow: $(".banner-instagram .count-3 .count-next"),
                dots: false,
                infinite: true,
                mobileFirst: true,
                autoplay: false,
                rows: 2,
                slidesPerRow: 2,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 5,
                            rows: 1,
                            slidesPerRow: 1,
                        }
                    }
                ]
            });
        }
    });

    waitForElementToExist('.banner-product').then(element => {
        $('#product-banner').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: true,
            prevArrow: $(".count-5 .count-prev"),
            nextArrow: $(".count-5 .count-next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
        });

        $('.banner-products').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
        });

        $('#product-banner').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.banner-products').slick('slickGoTo', nextSlide);
        });


        $('#product-banner').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });
})